import * as React from 'react';
import {createStyles, Dialog, makeStyles, Theme} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from "@material-ui/core/IconButton";
import {useState} from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import HelpIcon from '@material-ui/icons/Help';
import { traducirButton, traducirLabel } from '../../blocks/traductor';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        btnHelp:{
            position: "absolute"
        }
    }),
);

export interface IHelp {
    comments: string;
    ayuda?:any;
    customStyle?: any;
    size?: string;
}

const Help = ({comments, ayuda, customStyle, size}: IHelp) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const openHelp = () => {
        setOpen(true);
    };

    const closeHelp = () => {
        setOpen(false);
    };

    const styleBtn = customStyle ? customStyle : {top: "-5px", right: "-5px"};

    return (<>
        <div style={{position: "relative"}}>
            <IconButton color="primary"  className={classes.btnHelp} style={styleBtn} onClick={openHelp}>
                {!size && <HelpIcon fontSize="default" />}
                {size === "small" && <HelpIcon fontSize="small" />}
                {size === "large" && <HelpIcon fontSize="large" />}
            </IconButton>
        </div>

        <Dialog onClose={closeHelp}  open={open} maxWidth="sm" fullWidth={true}>
            <DialogTitle id="simple-dialog-title">{traducirLabel(335)}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText style={{whiteSpace: "pre-line", textAlign: "justify"}}>
                    <div className="content" dangerouslySetInnerHTML={{__html: (comments)}}></div>                    
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={closeHelp} color="primary">
                    {/* Cerrar */
                    traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};

export default Help;
